const TICKET_CODES = {
    ADULT: 'ADULT',
    CHILD: 'CHILD',
    TODDLER: 'INFANT',
    FAMILY: 'FAMILY',
}

const CLASS_CODES = {
    FLEXY: 'FLEXY',
    DISCOUNTED: 'DISCOUNTED',
    FAMILY: 'FAMILY',
    GREEK: 'GREEK',
}

const FAMILY_PRICE = 50.00
const FAMILY_DISCOUNTED_PRICE = 40.00;
const FAMILY_ADULTS_PRICE = 15.00;
const FAMILY_CHILDREN_PRICE = 10.00;

const PAYMENT_GATEWAYS = {
    XPAY: 982, // 1,
    CARDLINK: 982, // 1,
    PAYPAL: 981, // 2,
}


const CARDLINK_ROUTE_URL = '/app/transaction/cardlink_route.php';
const XPAY_ROUTE_URL = '/app/transaction/xpay_route.php';
const PAYPAL_ROUTE_URL = '/app/transaction/paypal_route.php';

const TRANSFER_TYPE = {
    NO_TRANSFER: 0,
    BUS_TRANSFER: 1,
    PRIVATE_TRANSFER: 2,
}

const CART_VIEW = {
    MAIN_VIEW: 0, // Main menu. Tickets or Transfer
    BUS_TRANSFER: 1,
    PRIVATE_TRANSFER: 2,
    TICKETS: 3,
}

export {
    CART_VIEW,
    TICKET_CODES,
    CLASS_CODES,
    FAMILY_PRICE,
    FAMILY_DISCOUNTED_PRICE,
    FAMILY_ADULTS_PRICE,
    FAMILY_CHILDREN_PRICE,
    TRANSFER_TYPE,
    PAYMENT_GATEWAYS,
    CARDLINK_ROUTE_URL,
    PAYPAL_ROUTE_URL,
    XPAY_ROUTE_URL
}